import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SmallSpinner } from 'yankees-react-utils';
import PlayerSelector from '../../../components/PlayerSelector';
import { store, actions } from '../../../store';
import usePlayerSelector from '../../../utils/usePlayerSelector';
import { usePlayerGamesQuery } from '../../../data';
import useOpposingTeamSelector from '../../../utils/useOpposingTeamSelector';

const MatchupPitcherSelector = ({ onSelect, showGenericLhhRhh }) => {
    const { t: translate } = useTranslation();
    const userPlayer = usePlayerSelector();
    const opposingTeam = useOpposingTeamSelector();
    const { dispatch, state: { matchupSelectedPitcher } } = useContext(store);
    const [pitcher, setPitcher] = useState(matchupSelectedPitcher);

    useEffect(() => {
        if (pitcher) {
            if (pitcher.PlayerID > 2) { // We don't want to write the generic R/L Pitchers into the dropdown memory
                dispatch({ type: actions.SET_MATCHUP_SELECTED_PITCHER, data: pitcher });
            }
            onSelect({ ...pitcher });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pitcher]);

    const { isLoading: isLoadingStartingPitchers } = usePlayerGamesQuery({
        enabled: !!opposingTeam && !window.$IsDugoutApp,
        select: (resp) => ({
            ...resp,
            probables: resp.series.filter((s) => s.TeamID === Number(opposingTeam.TeamID)).flatMap(({ games, isHomeSeries }) => {
                const probables = games.map((g) => (isHomeSeries ? g.GameProbables?.HomeStarter : g.GameProbables?.AwayStarter));
                return probables.filter((x) => x?.PlayerID);
            }),
        }),
        onSuccess: ({ probables }) => {
            if (!pitcher?.PlayerID && probables?.length) setPitcher({ ...probables[0], name: probables[0].FullName, value: probables[0].PlayerID });
        },
    });

    return (
        <>
            {isLoadingStartingPitchers && <SmallSpinner />}
            <PlayerSelector
                teamid={userPlayer.TeamID}
                position="pitcher"
                player={Object.keys(pitcher).length ? pitcher : `${translate('common.select')}...`}
                onSelect={setPitcher}
                showGenericLhhRhh={showGenericLhhRhh}
            />
        </>
    );
};

MatchupPitcherSelector.propTypes = {
    onSelect: PropTypes.func.isRequired,
    showGenericLhhRhh: PropTypes.bool,
};
MatchupPitcherSelector.defaultProps = {
    showGenericLhhRhh: false,
};

export default MatchupPitcherSelector;
